import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LogService} from "../../../services/log.service";
import {AddCounsellingLogComponent} from "../counselling-log-table/add-counselling-log/add-counselling-log.component";
import {needConfirmation} from "../../../confirm-dialog/confirm-dialog.decorator";
import {AddEducationLogComponent} from "./add-education-log/add-education-log.component";
import {LogVerifyDialogComponent} from "../log-verify-dialog/log-verify-dialog.component";
import {CentreService} from "../../../services/centre.service";
import {MatSelectChange} from "@angular/material/select";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
    selector: 'app-education-log-table',
    templateUrl: './education-log-table.component.html',
    styleUrls: ['./education-log-table.component.scss']
})
export class EducationLogTableComponent implements OnInit, OnDestroy {
    private _destroyed$ = new Subject<void>();
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    selectedCentre: string='All';
    centres$
    userRole = ''
    userName = ''

    displayedColumns = ['conductedBy', 'centreName', 'sessionType', 'floor', 'sessionDate', 'createdAt', 'status', 'action'];
    dataSource = new MatTableDataSource<any>();
    mData: any[] = []

    constructor(private readonly mDialog: MatDialog,
                private readonly mSnackbar: MatSnackBar,
                private  readonly  mCentreService:CentreService,

                private readonly mLogService: LogService) {
        this.dataSource = new MatTableDataSource<any>()
        const userData = JSON.parse(localStorage.getItem('userData')!)
        this.userRole = userData?.role
        this.userName = userData?.userName
        this.centres$ =this.mCentreService.getAllCentres()

    }

    ngOnInit(): void {
        this.mLogService.fetchEducationLogs(this.selectedCentre).pipe(takeUntil(this._destroyed$)).subscribe(res => {
            this.mData = res

            this.dataSource.data = this.mData; // Assuming formData contains your data
            this.dataSource.sort = this.sort
            this.dataSource.paginator = this.paginator
        })


    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

    addLog() {
        this.mDialog.open(AddEducationLogComponent)
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }


    changeStatus(element: any) {
        if (this.userRole == "Centre Manager"||"Developer") {
            // this.mLogService.updateEducationStatus(element)
            this.mDialog.open(LogVerifyDialogComponent, {
                data: {
                    ref: `EducationLogs/${element.id}`,
                    status: element.status
                }
            })
        } else {
            this.mSnackbar.open('Only for Centre Manager', "", {
                panelClass: 'error',
                duration: 3000
            })
        }
    }
    onCentreChange($event: MatSelectChange) {
        this.mLogService.fetchCounsellingLog(this.selectedCentre).pipe(takeUntil(this._destroyed$)).subscribe(res=>{
            this.mData =res

            this.dataSource.data = this.mData; // Assuming formData contains your data
            this.dataSource.sort =this.sort
            this.dataSource.paginator =this.paginator
        })
    }

    @needConfirmation()
    delete(element: any) {
        this.mLogService.deleteEducationLog(element.id).then(res => {
            this.mSnackbar.open('Deleted Successfully!', "", {
                panelClass: 'success',
                duration: 3000
            })
        })
    }
}

